import { useEffect } from 'react';
import { AppRouter } from './routes/router';
import { useThemeStore } from './stores/theme';

export function App() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return <AppRouter />;
}
